module.exports = __webpack_public_path__ + "assets/img/5_1262.f196962a.jpg";